import React from 'react';

const context = React.createContext(null);

export default context;
